module.exports = __webpack_public_path__ + "static/media/logout.642b152c.svg";